import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Modal,
  Grid,
  Stack,
  Pagination,
  Checkbox,
  Select,
  OutlinedInput,
  MenuItem,
  ListItemText,
  FormControl,
  InputLabel,
  InputAdornment,
  IconButton,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";

import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

import { useSelector } from "react-redux";

// import DatePicker from "react-datepicker";
import EventIcon from "@mui/icons-material/Event";
import SearchIcon from "@mui/icons-material/Search";
import {
  AddCashPayment,
  addCustomerAdvance,
  getCounterSalesCustomers,
  getUnpaidUser,
} from "./paymentReceiptApi";
import UserCard from "./userCard";
import Swal from "sweetalert2";
import {
  displayDateFormat,
  getFirstDateOfCurrentMonthPayloadFormate,
  getLastDateOfCurrentMonthPayloadFormat,
  swalAlertPopProps,
} from "../../utils/commonUtils";
import { validationAdd } from "./paymentReceiptValidations";
import { searchedElementDisplay } from "./receiptFunctions";
import { monthInText } from "./paymentReceiptDateFunction";
import PayrolSearchModal from "../employeePayRoll/payrollSearchModal";
import { GetAssistancePayrollDetail } from "../employeePayRoll/outstandingApi";
import { ModalHeader } from "../../common/modalHeader";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import calendar from "../../assets/icon/calendarblack.png";

export default function AddReceipt({
  open,
  setOpen,
  getRecept,
  unPaidBill,
  setUnPaidBill,
  upPaidBillData,
  setUnPaidBillData,
  billData,
  setBillData,
  searchModal,
  setSearchModal,
  callback,
}) {
  const [pagination, setPagination] = useState({ page: 1, total: 10 });
  const [search, setSearch] = useState("");
  // const [upPaidBillData, setUnPaidBillData] = useState();
  const [errors, setErrors] = useState({
    name: "",
    amount: "",
    paymentMethod: "",
    transactionDetails: "",
    reason: "",
  });

  const data = {
    customerMobile: "",
    amount: null,
    paymentMethod: "Cash",
  };

  const { userDetail } = useSelector((state) => state.reducer);

  const onClose = () => {
    setOpen(false);
  };
  const handleChange = (event, value) => {
    setPagination({
      ...pagination,
      page: value,
    });
  };
  const getUnpaid = async (param) => {
    await getUnpaidUser(param)
      .then((res) => {
        console.log("unPaid user", res?.data?.data[0]);

        setUnPaidBillData(res?.data?.data[0]);
      })
      .catch((err) => {});
  };

  const [USerObject, setUSerObject] = useState(null);

  const [startDateFormat, setstartDateFormat] = useState(
    getFirstDateOfCurrentMonthPayloadFormate()
  );
  const [endDate, setEndDate] = useState(
    getLastDateOfCurrentMonthPayloadFormat()
  );
  const [counterSalesHeader, setCounterSalesHeader] = useState(null);
  const [billFilter, setBillFilter] = useState(null);

  const [payloadGetCounterSales, setPayloadGetCounterSales] = useState({
    page: 1,
    pageSize: pagination.pageSize,
    sortBy: "",
    order: 0,
    buyerGroupId: 0,
    filter: "",
    search: "",
  });
  const getCounterSalesCusomter = async (param) => {
    await getCounterSalesCustomers(param).then((res) => {
      console.log("countersales res data   ", res?.data?.data, " ", {
        page: res.data.pageNumber,
        total: res.data.totalPages,
      });
      setPagination({
        page: res.data.pageNumber,
        total: res.data.totalPages,
      });
      setUnPaidBill([...res?.data?.data]);
    });
  };
  const addBill = async (param) => {
    await AddCashPayment(param)
      .then((res) => {
        console.log("add Bill ", res?.data?.succeeded);
        if (res?.data?.succeeded) {
          getRecept();
          Swal.fire({
            text: "Saved Record",
            icon: "success",

            ...swalAlertPopProps,
          });
        } else {
          Swal.fire({
            text: res?.data?.message,
            icon: "error",

            ...swalAlertPopProps,
          });
        }
      })
      .catch((err) => {
        console.log("err ", err);
      });
  };
  useEffect(() => {
    if (open === true) {
      getCounterSalesCusomter({
        filter: "",
        search: "",
        page: 1,
        pageSize: 1000,
      });
      setBillData({ ...billData, mybusinessId: userDetail?.myBusinessId });
    } else {
      console.log("close");
      setBillData(data);
      setUnPaidBillData();
    }
  }, [open]);
  const addLeadingZero = (value) => {
    return value < 10 ? "0" + value : value;
  };
  const [date, setDate] = useState(dayjs());
  const [startDate, setStartDate] = useState(dayjs().format("YYYY-MM-DD"));

  const datePickerRef = useRef();

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };
  useEffect(() => {
    console.log("billData ", billData);
  }, [billData]);

  const handleTagsChange = (e) => {
    const { value } = e.target;
    setBillData({
      ...billData,
      paymentMethod: value, // Corrected typo from paymentMedthod to paymentMethod
    });
  };

  // const [status, setStatus] = useState("all");
useEffect(() => {
  if (USerObject?.name && errors.name) {
    // Clear the employee error once a valid employee is selected
    setErrors((prevErrors) => {
      const { name, ...rest } = prevErrors;
      return rest;
    });
  }
}, [USerObject, errors.name]);
  return (
    <Modal
      open={open}
      onClose={onClose}
      fullWidth={true}
      maxWidth="xs"
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "40%", md: "40%", lg: "40%", xl: "40%" },

          overflowY: "auto",
          // height: "65vh",
          position: "absolute",
          borderRadius: "10px",
          left: { xs: "2%", sm: "25%", md: "35%", lg: "35%", xl: "30%" },

          top: "10%",
        }}
      >
        {/* <DialogTitle
          color="primary"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "auto",
            p: "0px 10px !important",
          }}
        >
          Advance Payment Receipts{" "}
          <CloseIcon
            sx={{ float: "right", cursor: "pointer" }}
            onClick={() => setOpen(false)}
          />
        </DialogTitle> */}

        <ModalHeader title="Advance Payment" onClose={onClose} />
        <Divider />
        <Grid container sx={{ position: "relative" }}>
          <Grid item xs={12} sm={12}>
            <DialogContent>
              <Box sx={{ cursor: "pointer" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={date ? dayjs(date, "DD-MM-YYYY") : null}
                    onChange={(newValue) => {
                      setDate(newValue);
                      setStartDate(newValue.format("YYYY-MM-DD"));
                    }}
                    format="DD-MM-YYYY"
                    error={!date}
                    maxDate={dayjs()}
                    slots={{ openPickerIcon: CalendarMonthIcon }}
                    InputLabelProps={{
                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    slotProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton edge="end">
                            <Box
                              component="img"
                              src={calendar}
                              alt="calendar icon"
                              sx={{
                                width: 20,
                                height: 20,
                                cursor: "pointer",
                              }}
                            />
                          </IconButton>
                        </InputAdornment>
                      ),
                      textField: {
                        fullWidth: true,
                        label: "Date :",
                        size: "small",
                        InputProps: {
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton edge="end">
                                <Box
                                  component="img"
                                  src={calendar}
                                  alt="calendar icon"
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    cursor: "pointer",
                                  }}
                                />
                              </IconButton>
                            </InputAdornment>
                          ),
                          sx: { background: "#fff", borderRadius: 1 },
                        },
                      },
                      openPickerIcon: {
                        // sx: { color: "#000" },
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>

              <Box
                onClick={() => {
                  setSearchModal(true);
                }}
                sx={{
                  display: "flex",
                  height: "23px",
                  justifyContent: "space-between",
                  border: "2px solid #01008BA8",
                  p: 1,
                  px: "20px",
                  mt: 2,
                  borderRadius: "4px ",
                  fontFamily: "Montserrat",
                  color: "#545454",
                  "&:hover": {
                    cursor: "pointer !important",
                  },
                }}
              >
                <Typography
                  variant="p"
                  // helperText={errors.name}
                  fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
                >
                  {console.log(USerObject?.name, "billData.name")}
                  {USerObject?.name !== undefined
                    ? USerObject.name
                    : "Select Employee :"}
                </Typography>
                <SearchIcon
                  onClick={() => {
                    setSearchModal(true);
                  }}
                  sx={{
                    // color: (theme) => theme.palette.primary.main,
                    cursor: "pointer",
                  }}
                />
              </Box>
              {errors.name && (
                <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                  {errors.name}
                </Typography>
              )}
              <Box sx={{ mt: 2 }}>
                <TextField
                  fullWidth
                  id="amount"
                  label="Amount :"
                  size="small"
                  value={billData.amount}
                  onChange={(e) => {
                    setBillData({ ...billData, amount: e.target.value });
                    setErrors((prev) => ({ ...prev, amount: "" })); // clear error on change
                  }}
                  error={Boolean(errors.amount)}
                  helperText={errors.amount}
                  InputLabelProps={{
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                />
              </Box>
              <Box
                sx={{
                  mt: 2,
                  width: { xs: "86%", sm: "85%", md: "90%", lg: "92%" }, // ✅ Responsive
                  border: "2px solid #01008BA8",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  padding: "4px 20px",
                  gap: 2, // smaller gap looks better on mobile
                }}
              >
                <Typography
                  sx={{
                    color: "#01008B",
                    fontWeight: 500,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    minWidth: "120px", // enough space for label
                  }}
                >
                  Payment Mode
                </Typography>

                <Select
                  size="small"
                  name="paymentMethod"
                  value={billData?.paymentMethod || "Cash"}
                  onChange={handleTagsChange}
                  disableUnderline
                  variant="standard"
                  InputLabelProps={{
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  fullWidth // ✅ Makes Select grow in remaining space
                  sx={{
                    backgroundColor: "transparent",
                    ".MuiSelect-select": {
                      paddingY: 0.5,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    },
                  }}
                >
                  <MenuItem value="Online">Online</MenuItem>
                  <MenuItem value="Cash">Cash</MenuItem>
                  <MenuItem value="Cheque">Cheque</MenuItem>
                </Select>
              </Box>

              <Box sx={{ mt: 2 }}>
                <TextField
                  fullWidth
                  id="transactionDetails"
                  size="small"
                  label="Transaction / Cheque No :"
                  value={billData?.transactionDetails}
                  onChange={(e) => {
                    setBillData({
                      ...billData,
                      transactionDetails: e.target.value,
                    });
                    setErrors((prev) => ({ ...prev, transactionDetails: "" }));
                  }}
                  error={errors.transactionDetails}
                  helperText={errors.transactionDetails}
                  InputLabelProps={{
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                />
              </Box>
              <Box sx={{ mt: 2 }}>
                <TextField
                  fullWidth
                  id="reason"
                  size="small"
                  label="Reason :"
                  value={billData?.reason}
                  onChange={(e) => {
                    setBillData({
                      ...billData,
                      reason: e.target.value,
                    });
                    setErrors((prev) => ({ ...prev, reason: "" }));
                  }}
                  error={errors.reason}
                  helperText={errors.reason}
                  InputLabelProps={{
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                />
              </Box>
            </DialogContent>
          </Grid>
        </Grid>

        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
          {/* <Button onClick={onClose}>Cancel</Button> */}
          <Button
            variant="contained"
            fullWidth
            sx={{
              width: "90%",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
            onClick={() => {
              const newErrors = {};

              if (
                !billData.amount ||
                isNaN(billData.amount) ||
                parseFloat(billData.amount) <= 0
              ) {
                newErrors.amount = "Enter a valid amount greater than 0";
              }

              if (!billData.paymentMethod) {
                newErrors.paymentMethod = "Payment method is required";
              }

              if (!billData.transactionDetails?.trim()) {
                newErrors.transactionDetails =
                  "Transaction details are required";
              }

              if (!billData.reason?.trim()) {
                newErrors.reason = "Reason is required";
              }
              if (!USerObject?.name) {
                newErrors.name = "Select Employee";
              }
              // If any errors exist, set them and return early
              if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
              }

              // All validation passed
              addCustomerAdvance(
                {
                  buyerInfoId: USerObject?.id,
                  amount: parseFloat(billData.amount),
                  date: startDate,
                  paymentMethod: billData.paymentMethod,
                  transactionDetails: billData.transactionDetails,
                  reason: billData.reason,
                },
                () => {
                  setOpen(false);
                  setUSerObject("");
                  callback();
                }
              );
            }}
          >
            Save
          </Button>
        </DialogActions>
        <PayrolSearchModal
          searchModal={searchModal}
          setSearchModal={setSearchModal}
          unPaidBill={unPaidBill}
          getUnpaid={getUnpaid}
          setBillData={setBillData}
          search={search}
          setSearch={setSearch}
          setUSerObject={(data) => {
            console.log("data ", data);
            GetAssistancePayrollDetail(
              {
                fromDate: startDateFormat,
                toDate: endDate,
                employeeMasterId: data?.id,
                page: 1,
                pageSize: 1000,
                workingDays: 0,
              },
              (data) => {
                console.log("data == ", data);
                setCounterSalesHeader(data?.data);
              }
            );
            setUSerObject(data);
          }}
          setUnPaidBill={setUnPaidBill}
          setUnPaidBillData={setUnPaidBillData}
          setPagination={setPagination}
          billData={billData}
          callSearchApi={(searchName) => {
            setBillFilter("");
            // payloadGetCounterSales.search
            setPayloadGetCounterSales({
              ...payloadGetCounterSales,
              search: "",
            });
            // getCounterSales(
            //   {
            //     page: 1,
            //     pageSize: 10000,
            //     sortBy: "",
            //     order: 0,
            //     buyerGroupId: 0,
            //     filter: "buyername",
            //     search: searchName,
            //   },
            //   outStandingBills,
            //   getCounterSalesStatement,
            //   setNumberOfRecords,
            //   setOutStandingBills
            // );
          }}
          //  userDetail={userDetail}
        />
      </Box>
    </Modal>
  );
}
